import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { apiDelete, apiGet, apiPost } from "../../../components/Common/Axios";
import { UserRole } from "../../../lib/types";
import Popup from "../../../components/Common/Popup";
import UserPopup from "./UserPopup";
import { User } from "lib/models";
import { Button } from "components/ui/button";

function SettingUsers() {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState<User | undefined>(undefined);
  const [openPopup, setOpenPopup] = useState(false);
  const [newMode, setNewMode] = useState(false);

  const loadUsers = async () => {
    const response = await apiGet("/users");
    if (response.error) {
      toast.error("사용자 목록을 불러오는데 실패했습니다.");
      console.error("loadUsers.error", response.error);
      return;
    }
    setUsers(response.data);
    setSelectedUser(undefined);
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const handleSaveUser = async (
    user: User,
    password: string,
    newMode: boolean
  ) => {
    const userPassword = { user, password, newMode };

    const response = await apiPost("/user/info", userPassword);
    if (response.error) {
      toast.error("사용자 정보를 저장하는데 실패했습니다.");
      console.error("handleSaveUser.error", response.error);
      return;
    }
    await loadUsers();
  };

  const handleDeleteUser = async (user: User) => {
    const response = await apiDelete(`/user/info/${user.id}`);
    if (response.error) {
      toast.error("사용자 정보를 삭제하는데 실패했습니다.");
      console.error("handleDeleteUser.error", response.error);
      return;
    }
    await loadUsers();
  };

  const handleNewUserPopup = () => {
    setSelectedUser({
      id: 0,
      name: "",
      email: "",
      role: UserRole.USER,
    });
    setNewMode(true);
    setOpenPopup(true);
  };

  const handleEditUserPopup = (user: User) => {
    setSelectedUser(user);
    setNewMode(false);
    setOpenPopup(true);
  };

  return (
    <div className="w-full">
      <Popup open={openPopup} setOpen={setOpenPopup}>
        <UserPopup
          newMode={newMode}
          user={selectedUser!}
          onClose={() => setOpenPopup(false)}
          onSave={handleSaveUser}
          onDelete={handleDeleteUser}
        />
      </Popup>
      <div className="flex justify-end pb-3">
        <Button variant="primary" onClick={() => handleNewUserPopup()}>
          추가
        </Button>
      </div>
      <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
        <div className="grid grid-cols-3 bg-gray-50 text-gray-500 font-medium p-2 border-b border-gray-200 border-solid">
          <div className="text-center">이름</div>
          <div className="text-center">아이디</div>
          <div className="text-center">역할</div>
        </div>
        {users.map((user: any) => {
          return (
            <div
              className="grid grid-cols-3 py-2 border-b border-gray-200 border-solid last:border-0 hover:bg-gray-50 cursor-pointer"
              key={user.id}
              onClick={() => handleEditUserPopup(user)}
            >
              <div className="text-center">{user.name}</div>
              <div className="text-center">{user.email}</div>
              <div className="text-center">
                {user.role === UserRole.USER
                  ? "사용자"
                  : user.role === UserRole.ADMIN
                  ? "관리자"
                  : "매니저"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default SettingUsers;
